import React, { useRef, useState, useEffect } from "react";
import {
  Box,
  Card,
  styled,
  Stepper,
  Step,
  StepButton,
  Button,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { H3, Paragraph, H4 } from "../../components/Typography";
import { load, save } from "../../constants/storage";
import FlexBox from "../../components/FlexBox";
import UploadCard from "../../components/UploadCard";
import AssistedUploadVideo from "../../components/AssistedUploadVideo";
import UploadVideo from "../../components/UploadVideo";
import { KYCFirstStep, KYCSecondStep } from "../index";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-hot-toast";
import * as Models from "../../models";
import { useAppDispatch } from "../../store/hooks";
import { getUserInfo } from "../../redux/actions/UserAction";
import DashboardNavbar from "../../components/DashboardNavbar";
import {
  getOtpMutualFund,
  createKycForMF,
  createInvestorMutualFund,
  createInvestmentMutualFund,
  uploadDocumentMF,
  getKYCStatus,
} from "../../redux/actions/KYCAction";
import KycOTPModel from "../../components/KycOTPModel";

const StyledCard = styled(Card)(() => ({
  position: "relative",
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
}));

const steps = ["Step 1", "Step 2", "Step 3"];

export default function KYCInformation() {
  const [activeStep, setActiveStep] = useState(0);

  const [complianceTrue, setCompliance] = useState(false);
  let routeData = useLocation();
  const { KYCStatus } = routeData.state;

  useEffect(() => {
    setActiveStep(KYCStatus);
  }, []);
  const [loading, setLoading] = useState(false);
  //upload images
  const [isSelfieVideoUploaded, setIsSelfieVideoUploaded] = useState(false);
  const [isAdreessFrontPageUploaded, setIsAdreessFrontPageUploaded] =
    useState(false);
  const [isAdreessBackPageUploaded, setIsAdreessBackPageUploaded] =
    useState(false);
  const [isPANUploaded, setIsPANUploaded] = useState(false);
  const [isSelfSignatureUploaded, setIsSelfSignatureUploaded] = useState(false);
  const [isUserPhontoUploaded, setIsUserPhontoUploaded] = useState(false);
  const [isBankAccountProofUploaded, setIsBankAccountProofUploaded] =
    useState(false);
  const [userInfo, setUserInfo] = useState<any>();
  const [OTP, setOTP] = useState("");
  //video
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const [recording, setRecording] = useState(false);
  const [recordedChunks, setRecordedChunks] = useState<Blob[]>([]);
  const [open, setOpen] = useState(false);
  const [timer, setTimer] = useState(0);
  const [startTimestamp, setStartTimestamp] = useState<number | null>(null);

  const dispatch = useAppDispatch();
  let interval: NodeJS.Timeout | null = null;

  let navigate = useNavigate();
  const [completed, setCompleted] = useState<{
    [k: number]: boolean;
  }>({});
  useEffect(() => {
    getOTP();
    getUserInfomation();
    loadUserData();
  }, []);

  //OTP model
  const [otpModel, setOTPModel] = useState(false);
  const handleOTPProceedHandle = async () => {
    setOTPModel(false);
    setOpen(true);
    setTimer(0);
    setRecording(false);
  };
  const handleOTPCloseHandle = async () => {
    setOTPModel(false);
    stopCamera();
  };

  useEffect(() => {
    if (recording) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer + 1);
      }, 1000);
    } else {
      clearInterval(interval as NodeJS.Timeout);
    }

    return () => {
      clearInterval(interval as NodeJS.Timeout);
    };
  }, [recording]);

  const loadUserData = async () => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);

    setIsAdreessBackPageUploaded(
      userDetails?.poi_back != null && userDetails?.poi_back != ""
    );
    setIsAdreessFrontPageUploaded(
      userDetails?.poi_front != null && userDetails?.poi_front != ""
    );
    setIsPANUploaded(
      userDetails?.poi_pan != null && userDetails?.poi_pan != ""
    );
    setIsUserPhontoUploaded(
      userDetails?.photo != null && userDetails?.photo != ""
    );
    setIsBankAccountProofUploaded(
      userDetails?.bank_acc_proof != null && userDetails?.bank_acc_proof != ""
    );
    setIsSelfSignatureUploaded(
      userDetails?.self_sign != null && userDetails?.self_sign != ""
    );
  };

  const getUserInfomation = async () => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    let token = load("token");
    const req: Models.GETUSER_INFO_REQUEST = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      source: "web",
    };

    dispatch(getUserInfo(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.statusCode === 400) {
          return;
        }
        if (response.data[0].kyc_verified === true) {
          setCompliance(true);
          return;
        }
        await save("userData", JSON.stringify(response?.data[0]));
        setUserInfo(response?.data[0]);
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const getOTP = async () => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    let token = load("token");

    const req: Models.MFKYCOTPREQUEST = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
    };

    dispatch(getOtpMutualFund(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.error) {
          toast.error("Not able to create OTP, please try after sometimes");
          return;
        }
        setOTP(response?.otp);
      })
      .catch((error: any) => {
        console.log("Update error:", error);
      });
  };

  const stopCamera = (): void => {
    if (videoRef.current && videoRef.current.srcObject) {
      setTimer(0);
      const stream = videoRef.current.srcObject as MediaStream;
      const tracks = stream.getTracks();
      tracks.forEach((track) => {
        track.stop();
      });
      videoRef.current.srcObject = null;
    }
  };

  const handleStartRecording = (): void => {
    setRecording(true);
    setRecordedChunks([]);
    setOpen(true);
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
    navigator.mediaDevices
      .getUserMedia({ video: true, audio: true })
      .then((stream) => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          const mediaRecorder = new MediaRecorder(stream);
          mediaRecorderRef.current = mediaRecorder;
          mediaRecorder.addEventListener("dataavailable", handleDataAvailable);
          mediaRecorder.start();
          setTimer(0);
          setStartTimestamp(Date.now());
        }
      })
      .catch((error) => {
        console.error("Error accessing camera:", error);
      });
  };

  const handleStopRecording = (): void => {
    setRecording(false);
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
    }
  };

  const handleDataAvailable = (event: BlobEvent): void => {
    if (event.data.size > 0) {
      setRecordedChunks((prevChunks) => [...prevChunks, event.data]);
    }
  };

  const handleVideoSubmit = (): void => {
    stopCamera();
    const blob = new Blob(recordedChunks, { type: "video/webm" });
    const fileSizeInBytes = blob.size;
    const fileSizeInMB = fileSizeInBytes / (1024 * 1024);

    if (fileSizeInMB > 10) {
      setLoading(false);
      toast.error("Video size exceeds 10 MB");
      setOpen(false);
      setTimer(0);
      return;
    } else {
      setTimer(0);
      setLoading(true);
      const file = new File([blob], "recorded-video.webm", {
        type: "video/webm",
      });

      // const file = new File([blob], "recorded-video.ebm", { type: "video/webm" });
      captureProof(file, "SELFIE_VIDEO");
      setOpen(false);
    }
  };

  const firstCompleteStep = (data: any, compliance: boolean) => {
    setCompliance(compliance);
    setActiveStep(activeStep + 1);
  };

  const secondBackStep = (data: any) => {
    setActiveStep(activeStep - 1);
  };

  const secondCompleteStep = (data: any) => {
    setActiveStep(activeStep + 1);
  };

  //handleAssistVideoChange
  const handleAssistVideoChange = (event: any) => {
    if (event.target.files && event.target.files[0]) {
      setLoading(true);
      const selectedFile = event.target.files[0];
      if (selectedFile && selectedFile.size <= 10 * 1024 * 1024) {
        captureProof(event.target.files[0], "SELFIE_VIDEO");
      } else {
        setLoading(false);
        toast.error("Please select an video file that is less than 10MB.");
      }
    }
  };

  //handleAddressPrrofFrontImageChange
  const handleAddressPrrofFrontImageChange = (event: any) => {
    if (event.target.files && event.target.files[0]) {
      setLoading(true);
      const selectedFile = event.target.files[0];
      if (selectedFile && selectedFile.size <= 5 * 1024 * 1024) {
        captureProof(event.target.files[0], "POI_FRONT");
        // setIsAdreessFrontPageUploaded(true);
      } else {
        setLoading(false);
        // Handle the case when the file is too large or no file is selected
        toast.error("Please select an image file that is less than 5MB.");
      }
    }
  };

  //handleAddressPrrofBackImageChange
  const handleAddressPrrofBackImageChange = (event: any) => {
    if (event.target.files && event.target.files[0]) {
      setLoading(true);
      const selectedFile = event.target.files[0];
      if (selectedFile && selectedFile.size <= 5 * 1024 * 1024) {
        captureProof(event.target.files[0], "POI_BACK");
      } else {
        setLoading(false);
        toast.error("Please select an image file that is less than 5MB.");
      }
    }
  };

  //PAN card Image
  const handlePANImageChange = (event: any) => {
    if (event.target.files && event.target.files[0]) {
      setLoading(true);
      const selectedFile = event.target.files[0];
      if (selectedFile && selectedFile.size <= 5 * 1024 * 1024) {
        captureProof(event.target.files[0], "POI_PAN");
      } else {
        setLoading(false);
        toast.error("Please select an image file that is less than 5MB.");
      }
    }
  };

  //handleSelfSignImageChange
  const handleSelfSignImageChange = (event: any) => {
    if (event.target.files && event.target.files[0]) {
      setLoading(true);
      const selectedFile = event.target.files[0];
      if (selectedFile && selectedFile.size <= 5 * 1024 * 1024) {
        captureProof(event.target.files[0], "SELF_SIGN");
      } else {
        setLoading(false);
        toast.error("Please select an image file that is less than 5MB.");
      }
    }
  };

  //handlePhotoImageChange
  const handlePhotoImageChange = (event: any) => {
    if (event.target.files && event.target.files[0]) {
      setLoading(true);
      const selectedFile = event.target.files[0];
      if (selectedFile && selectedFile.size <= 5 * 1024 * 1024) {
        captureProof(event.target.files[0], "PHOTO");
      } else {
        setLoading(false);
        toast.error("Please select an image file that is less than 5MB.");
      }
    }
  };

  //handleBankImageChange
  const handleBankImageChange = (event: any) => {
    if (event.target.files && event.target.files[0]) {
      setLoading(true);
      const selectedFile = event.target.files[0];
      if (selectedFile && selectedFile.size <= 5 * 1024 * 1024) {
        captureProof(event.target.files[0], "BANK_ACC_PROOF");
      } else {
        setLoading(false);
        toast.error("Please select an image file that is less than 5MB.");
      }
    }
  };

  const backHandle = () => {
    setActiveStep(activeStep - 1);
  };

  function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    if (!isSelfieVideoUploaded) {
      toast.error("Please upload the video");
      return;
    }
    if (!isAdreessFrontPageUploaded) {
      toast.error("Please upload address front page");
      return;
    }
    if (!isAdreessBackPageUploaded) {
      toast.error("Please upload address back page");
      return;
    }
    if (!isPANUploaded) {
      toast.error("Please upload PAN");
      return;
    }
    if (!isSelfSignatureUploaded) {
      toast.error("Please upload the self signed");
      return;
    }
    if (!isUserPhontoUploaded) {
      toast.error("Please upload the photo");
      return;
    }
    if (!isBankAccountProofUploaded) {
      toast.error("Please upload the back account proof");
      return;
    }

    createKYC();
  }

  const createKYC = async () => {
    let token = load("token");
    setLoading(true);
    const req: Models.MutualFundKYCRequestStatus = {
      id: userInfo.id,
      mobile: userInfo.mobile,
      partner: userInfo?.refcode,
    };
    dispatch(createKycForMF(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response?.error) {
          const message =
            response?.error?.error?.errors[0]?.field
              .replace(".", " ")
              ?.toUpperCase() +
            " " +
            response?.error?.error?.errors[0]?.message?.toUpperCase();
          if (
            response?.error?.error?.errors[0]?.field == "address.proof_number"
          ) {
            toast.error(message);
            setLoading(false);
            return;
          }
        }

        await createInvestor();
      })
      .catch((error: any) => {
        toast.error(error);
        setLoading(false);
      });
  };

  const createInvestor = async () => {
    let token = load("token");
    const req: Models.MutualFundKYCRequestStatus = {
      id: userInfo.id,
      mobile: userInfo.mobile,
      partner: userInfo?.refcode,
    };

    dispatch(createInvestorMutualFund(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response?.error) {
          toast.error(
            "Not able to create Investor account, please try after sometimes"
          );
          setLoading(false);
          return;
        }
        await createInvestment();
      })
      .catch((error: any) => {
        toast.error(error);
        setLoading(false);
      });
  };

  const createInvestment = async () => {
    let token = load("token");
    const req: Models.MutualFundKYCRequestStatus = {
      id: userInfo.id,
      mobile: userInfo.mobile,
      partner: userInfo?.refcode,
    };

    dispatch(createInvestmentMutualFund(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response?.error) {
          toast.error(
            "Not able to create Investment account, please try after sometimes"
          );
          setLoading(false);
          return;
        }
        await checkKYCStatus();
      })
      .catch((error: any) => {
        toast.error(error);
        setLoading(false);
      });
  };

  const checkKYCStatus = async () => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    let token = load("token");
    const req: Models.MutualFundKYCRequestStatus = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
    };

    dispatch(getKYCStatus(req, `bearer ${token}`))
      .then(async (response: any) => {
        navigate("/esign");
        setLoading(false);
      })
      .catch((error: any) => {
        toast.error(error);
        setLoading(false);
      });
  };

  const createFormData = async (fileData: any, purpose: string) => {
    const data = new FormData();
    let fileName;
    if (fileData.type === "video/mp4") {
      fileName = fileData.fileName + ".mp4";
    } else {
      fileName = fileData.fileName;
    }

    data.append("id", userInfo.id);
    data.append("mobile", userInfo.mobile);
    data.append("purpose", purpose);
    data.append("file", fileData);
    return data;
  };

  const captureProof = async (file: File, purpose: string) => {
    let token = load("token");
    const req = await createFormData(file, purpose);

    dispatch(uploadDocumentMF(req, `bearer ${token}`))
      .then(async (response: any) => {
        setLoading(false);
        if (response.error) {
          toast.error("File upload failled!");
          return;
        }
        if (purpose === "SELFIE_VIDEO") {
          setIsSelfieVideoUploaded(true);
          return;
        }
        if (purpose === "POI_FRONT") {
          setIsAdreessFrontPageUploaded(true);
          return;
        }
        if (purpose === "POI_BACK") {
          setIsAdreessBackPageUploaded(true);
          return;
        }
        if (purpose === "POI_PAN") {
          setIsPANUploaded(true);
          return;
        }
        if (purpose === "SELF_SIGN") {
          setIsSelfSignatureUploaded(true);
          return;
        }
        if (purpose === "PHOTO") {
          setIsUserPhontoUploaded(true);
          return;
        }
        if (purpose === "BANK_ACC_PROOF") {
          setIsBankAccountProofUploaded(true);
          return;
        }
      })
      .catch((error: any) => {
        setLoading(false);
        console.log("Update error:", error);
      });
  };

  return (
    <>
      <KycOTPModel
        open={otpModel}
        handleClose={handleOTPCloseHandle}
        handleSave={handleOTPProceedHandle}
        otp={OTP}
      />
      <DashboardNavbar />
      <StyledCard sx={mainContainer}>
        <H3 sx={mainHeadingText}>Complete your KYC</H3>
        <Stepper alternativeLabel activeStep={activeStep}>
          {steps.slice(0, complianceTrue ? 2 : 3).map((label, index) => (
            <Step key={label} completed={completed[index]}>
              <StepButton
                color="inherit"
                sx={
                  activeStep === index
                    ? {
                        "& .MuiSvgIcon-root": {
                          color: "#DD9401",
                          fontSize: "2rem",
                        },
                      }
                    : {
                        "& .MuiSvgIcon-root": {
                          color: "#002876",
                          fontSize: "2rem",
                        },
                      }
                }
              >
                {label}
              </StepButton>
            </Step>
          ))}
        </Stepper>
        <div>
          <React.Fragment>
            {/* fist Step */}
            {activeStep === 0 && (
              <KYCFirstStep
                onPress={(data: any, compliance: boolean) =>
                  firstCompleteStep(data, compliance)
                }
              />
            )}
            {/* second Step */}
            {activeStep === 1 && (
              <KYCSecondStep
                complice={complianceTrue}
                onBackPress={(data: any) => secondBackStep(data)}
                onPress={(data: any) => secondCompleteStep(data)}
              />
            )}
            {/* third Step */}
            {activeStep === 2 && (
              <>
                {loading ? (
                  <Grid
                    height="100vh"
                    display="flex"
                    flexDirection="column"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CircularProgress />
                  </Grid>
                ) : (
                  <form onSubmit={handleSubmit}>
                    <Box sx={container}>
                      <H3 sx={headingText}>Upload Documents</H3>
                      <Dialog
                        open={open}
                        onClose={() => {
                          setOpen(false);
                          stopCamera();
                          setRecording(false);
                        }}
                      >
                        <H4 fontSize={14} fontWeight={600} sx={{ p: 2 }}>
                          Note:Please read this OTP {OTP} aloud
                        </H4>
                        <Paragraph sx={{ p: 2, pb: 0 }}>
                          Recording Timer: {timer}s
                        </Paragraph>
                        <DialogContent>
                          {recording ? (
                            <video
                              ref={videoRef}
                              autoPlay
                              muted
                              style={{ width: "100%", height: "auto" }}
                            />
                          ) : (
                            <video
                              ref={videoRef}
                              autoPlay
                              muted
                              style={{ width: "0%", height: "0%" }}
                            />
                          )}
                        </DialogContent>
                        <DialogActions>
                          {!recording ? (
                            <Button
                              variant="contained"
                              onClick={handleStartRecording}
                              sx={add}
                            >
                              Start Recording
                            </Button>
                          ) : (
                            <>
                              <Button
                                variant="contained"
                                onClick={handleStopRecording}
                                sx={add}
                              >
                                Stop Recording
                              </Button>
                            </>
                          )}
                          <Button
                            variant="contained"
                            disabled={recordedChunks.length === 0}
                            onClick={handleVideoSubmit}
                            sx={add}
                          >
                            Submit Video
                          </Button>
                        </DialogActions>
                      </Dialog>

                      <Box
                        component="form"
                        noValidate
                        sx={{
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "column",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <FlexBox sx={viewContainer}>
                          {userInfo?.mode === "Assisted" ? (
                            <AssistedUploadVideo
                              title={"Video (Selfie)"}
                              subTitle={
                                "The investor has to speak each letter of this OTP " +
                                `${OTP}` +
                                " clearly inthe video. Also the video size should not be morethan 10 MB"
                              }
                              description={""}
                              onPress={handleAssistVideoChange}
                              uploaded={isSelfieVideoUploaded}
                            />
                          ) : (
                            <UploadVideo
                              title={"Video (Selfie)"}
                              subTitle={"Please Read the OTP clearly"}
                              description={""}
                              onClick={() => setOTPModel(true)}
                              uploaded={isSelfieVideoUploaded}
                            />
                          )}

                          <UploadCard
                            title={"Photo"}
                            subTitle={
                              "A Selfie Where face should be clearly visible"
                            }
                            description={""}
                            onPress={handlePhotoImageChange}
                            uploaded={isUserPhontoUploaded}
                          />
                        </FlexBox>
                        <FlexBox sx={viewContainer}>
                          <UploadCard
                            title={"Address Proof (Front Page)"}
                            subTitle={
                              "Passport (OR) Driving License (OR) Voter ID"
                            }
                            description={""}
                            uploaded={isAdreessFrontPageUploaded}
                            onPress={handleAddressPrrofFrontImageChange}
                          />
                          <UploadCard
                            title={"Address Proof (Back Page)"}
                            subTitle={
                              "Passport (OR) Driving License (OR) Voter ID"
                            }
                            description={""}
                            onPress={handleAddressPrrofBackImageChange}
                            uploaded={isAdreessBackPageUploaded}
                          />
                        </FlexBox>
                        <FlexBox sx={viewContainer}>
                          <UploadCard
                            title={"Identity Proof(PAN)"}
                            subTitle={""}
                            description={""}
                            onPress={handlePANImageChange}
                            uploaded={isPANUploaded}
                          />
                          <UploadCard
                            title={"Self Signed Signature"}
                            subTitle={""}
                            description={""}
                            onPress={handleSelfSignImageChange}
                            uploaded={isSelfSignatureUploaded}
                          />
                        </FlexBox>
                        <FlexBox sx={viewContainer1}>
                          <UploadCard
                            title={"Bank Account Proof"}
                            description={""}
                            subTitle={
                              "Note: Front scan of the cancelled cheque containing account number, name of the account holder and IFSC code."
                            }
                            onPress={handleBankImageChange}
                            uploaded={isBankAccountProofUploaded}
                          />
                        </FlexBox>
                      </Box>
                      <Box sx={sxStyleBox1}>
                        <Button
                          onClick={() => backHandle()}
                          variant="contained"
                          size="medium"
                          sx={sxStyleBackButton}
                        >
                          Back
                        </Button>
                        <Button
                          type="submit"
                          variant="contained"
                          size="medium"
                          sx={buttonStyle}
                        >
                          Next
                        </Button>
                      </Box>
                    </Box>
                  </form>
                )}
              </>
            )}
          </React.Fragment>
        </div>
      </StyledCard>
    </>
  );
}
const sxStyleBackButton = {
  mt: 3,
  mb: 2,
  py: 1,
  fontFamily: "'Poppins', sans-serif",
  width: {
    xs: "100%",
    sm: "100%",
    md: "40%",
  },
  alignSelf: "center",
  background: "#FFF5D1",
  color: process.env.REACT_APP_PRIMARY_COLOR,
  fontSize: "16px",
  fontWeight: "600",
};
const mainContainer = {
  margin: {
    xs: 2,
    sm: 2,
    md: 5,
  },
  marginLeft: {
    xs: 2,
    sm: 2,
    md: 20,
  },
  marginRight: {
    xs: 2,
    sm: 2,
    md: 20,
  },
  padding: {
    xs: 2,
    sm: 2,
    md: 5,
  },
};
const buttonStyle = {
  mt: 3,
  mb: 2,
  py: 1,
  fontFamily: "'Poppins', sans-serif",
  width: {
    xs: "100%",
    sm: "100%",
    md: "40%",
  },
  alignSelf: "center",
  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
};
const sxStyleBox1 = {
  alignItems: "center",
  justifyContent: "space-around",
  flexDirection: {
    xs: "column",
    sm: "column",
    md: "row",
  },
  display: "flex",
  mt: 2,
};
const mainHeadingText = {
  mb: 3,
  textAlign: "left",
  fontFamily: "'Poppins', sans-serif",
};
const headingText = {
  mt: 3,
  textAlign: "left",
  fontFamily: "'Poppins', sans-serif",
};
const container = {};
const viewContainer = {
  alignItems: "center",
  justifyContent: "space-between",
  flexDirection: {
    xs: "column",
    sm: "column",
    md: "row",
  },
  display: "flex",
  width: "100%",
  marginTop: {
    xs: 0.2,
    sm: 0.2,
    md: 2,
  },
};
const viewContainer1 = {
  width: "100%",
  marginTop: {
    xs: 0.2,
    sm: 0.2,
    md: 2,
  },
};
const add = {
  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
  color: "#fff",
  width: {
    md: "40%",
    xs: "40%",
  },
  mb: 1,
  borderRadius: 2,
};
